import ProfileStore from 'mewe/stores/profile-store';
import EmberObject from '@ember/object';
import Route from 'mewe/routes/route';
import PublicPagesApi from 'mewe/api/public-pages-api-unauth';
import {
  fetchFeedOpenProfile,
  getOpenProfileFeed,
  fetchFeedPagePublic,
  getOpenPageFeed,
} from 'mewe/fetchers/fetch-feed';
import { storePages, getPage } from 'mewe/fetchers/fetch-pages';
import { FeedTypes, Theme, PUBLIC_ENTITY_TYPE } from 'mewe/constants';
import Session from 'mewe/shared/session';
import { inject as service } from '@ember/service';

export default Route.extend({
  analytics: service(),
  dynamicPopups: service(),
  router: service(),

  queryParams: {
    mergeId: {
      refreshModel: true,
    },
  },

  init() {
    this._super(...arguments);
    this.dynamicPopups.setupPopupWormhole();
  },

  async beforeModel(transition) {
    let { to: toRouteInfo } = transition;
    let publicId = toRouteInfo.params.contact_public_id;
    let { isAuthenticated } = await Session.isAuthenticated();
    this.queryParams = toRouteInfo.queryParams;

    if (isAuthenticated) {
      this.router.transitionTo('app.publicid', publicId);
    } else {
      this.fetchPublicProfile(publicId);
    }
  },

  model(params) {
    const publicId = params.contact_public_id;

    if (!publicId) {
      return;
    }

    const model = EmberObject.create({
      publicId: publicId,
      contact: EmberObject.create({}),
      page: EmberObject.create({}),
      feed: null,
      entityType: null,
    });

    return model;
  },

  fetchPublicProfile(publicId) {
    // not authenticated user => use public API to get the profile
    PublicPagesApi.contact(publicId)
      .then((data) => {
        this.set('currentModel.entityType', data.entityType);
        this.analytics.sendEvent('openContentViewed', { content: data.entityType });

        if (PUBLIC_ENTITY_TYPE.PROFILE === data.entityType) {
          const uuid = data.user.id;
          ProfileStore.send('handleRawData', data);
          this.set('currentModel.contact', ProfileStore.getState({ uuid }));
          this.set(
            'currentModel.feed',
            getOpenProfileFeed(publicId, {
              theme: Theme.PROFILE,
              type: FeedTypes.DISCOVER,
            })
          );

          // fetch feed only if the profile is public
          if (data.public) {
            fetchFeedOpenProfile(publicId, uuid);
          }

          if (this.queryParams.mergeId) {
            this.set('currentModel.inId', this.queryParams.mergeId);

            PublicPagesApi.inviteeData(this.queryParams.mergeId).then((data) => {
              if (data?.email) {
                this.set('currentModel.email', data.email);
              }
            });
          }
        } else if (PUBLIC_ENTITY_TYPE.PAGE === data.entityType) {
          const uuid = data.id;
          data['isOpenPage'] = true;
          storePages([data]);
          this.set('currentModel.page', getPage(uuid));
          this.set('currentModel.feed', getOpenPageFeed(uuid));
          fetchFeedPagePublic(uuid);
        } else {
          location.href = '/404';
        }
      })
      .catch((error) => {
        console.log('error', error);

        if (error?.status === 404) {
          location.href = '/404';
        }
      });
  },
});
